import {Module} from "../index";
import messages from "./resources/messages";
import {routes} from "./resources/routes";
import {GameCreationEventSubscriber} from "./subscribers/GameCreationEventSubscriber";
import {AchievementsEventSubscriber} from "./subscribers/AchievementsEventSubscriber";
import {TYPES} from "./types";
import {AchievementHandlerInterface, RewarderInterface} from "@/modules/archiements/interfaces";
import Rewarder from "@/modules/archiements/services/Rewarder";
import LocalAchievementHandler from "@/modules/archiements/services/LocalAchievementHandler";
import {MenuNavigationComponentManager} from "@/modules/vue/services/MenuNavigationComponentManager";
import {ColorEnum, IconEnum} from "@/modules/vue/enums";
import {
  AchievementActionScreenEventSubscriber
} from "@/modules/archiements/subscribers/AchievementActionScreenEventSubscriber";

export class AchievementsModule extends Module {
  messages = messages;
  routes = routes;

  public entities = [];

  eventSubscribers = [
    GameCreationEventSubscriber,
    AchievementsEventSubscriber,
    AchievementActionScreenEventSubscriber,
  ];

  protected register() {
    super.register();

    this.app.bind<RewarderInterface>(TYPES.Rewarder).to(Rewarder);
    this.app.bind<AchievementHandlerInterface>(TYPES.AchievementHandler).to(LocalAchievementHandler);
  }

  boot() {
    super.boot();

    this.app.get(MenuNavigationComponentManager).addItem({
      icon: IconEnum.Reward20Regular,
      color: ColorEnum.Gold,
      route: {name: 'achievements.index'}
    });
  }
}
